import { z } from 'zod';
/**
 * Contracts for the admin "test identity" probe (`POST /api/identity/test`).
 *
 * The probe is an ephemeral connectivity/mapping check against the real WIT
 * identity API: an admin enters an email and sees what the upstream returns.
 * Nothing is persisted — these DTOs are the single source of truth shared by
 * the admin API route and the admin-web module.
 */
/** Request body: the email to probe. Trimmed; must be a valid address. */
export const IdentityTestRequest = z.object({
    email: z
        .string()
        .trim()
        .email('Некорректный email')
        .meta({ label: 'Email', placeholder: 'user@example.com' }),
});
/**
 * Mapped upstream identity. `age` is derived from `birthdate` server-side at
 * probe time (never stored). All profile fields are nullish — the upstream
 * frequently omits them.
 */
export const IdentityTestIdentity = z.object({
    witUserId: z.string(),
    displayName: z.string().nullish(),
    gender: z.string().nullish(),
    birthdate: z.string().nullish(),
    age: z.number().nullable(),
    source: z.string().nullish(),
});
/**
 * Probe outcome (flat + explicit). Every probe outcome is HTTP 200 so the UI
 * renders each case cleanly; the only non-200 is a 400 for a malformed request
 * body (a client bug — the form always posts a valid email):
 *   - `configured: false`               → identity API not wired on the server.
 *   - `configured: true, found: false, error: null`   → email not found upstream.
 *   - `configured: true, found: false, error: <msg>`  → lookup failed (HTTP/network).
 *   - `configured: true, found: true,  identity: {…}` → mapped identity present.
 */
export const IdentityTestResponse = z.object({
    configured: z.boolean(),
    found: z.boolean(),
    identity: IdentityTestIdentity.nullable(),
    error: z.string().nullable(),
});
//# sourceMappingURL=identity.js.map